import { useCallback } from 'react';

import { TId } from '@/features/common';
import { TestType, TTestType, useCreateTestMutation } from '@/features/test';
import { useHistory, useWorkspaceId } from './router';

export const useCreateCustomTest = () => {
  const workspaceId = useWorkspaceId();
  const history = useHistory();
  const createTestMutation = useCreateTestMutation();

  return useCallback(
    async (
      jobOpeningId: TId,
      stageId: TId,
      testType: TTestType
    ): Promise<void> => {
      createTestMutation.mutate(
        {
          jobOpeningId,
          attributes: {
            type: testType,
            name: `${testType === TestType.Video ? 'Async Interview' : testType === TestType.Homework ? 'Homework task' : 'Skills Test'}`,
            durationInSeconds: 0,
            percentToPass: 0,
            isQuestionRatingDisabled: false,
            pipelineStageId: stageId,
            skills: [],
          },
        },
        {
          onSuccess: async (test) => {
            history.push(
              `/admin/${workspaceId}/openings/${jobOpeningId}/test/${test.id}/questions`
            );
          },
        }
      );
    },
    [history, workspaceId, createTestMutation]
  );
};
